// Next Imports
import { Navigate, useLocation } from 'react-router-dom'

// Config Imports
import themeConfig from '@configs/themeConfig'

const AuthRedirect = () => {
  const { pathname } = useLocation()
  const redirectUrl = `/cms/login?redirectTo=${pathname}`
  const login = `/cms/login`
  const homePage = themeConfig.homePageUrl

  // Nếu đã ở trang login thì không cần redirect nữa
  if (pathname === login || pathname === homePage) {
    return <Navigate to={login} replace />
  }

  return <Navigate to={redirectUrl} replace />
}

export default AuthRedirect
